<template>
    <s-modal
            :open="open"
            :close="true"
            @close="$emit('close')"
            title="Configure la partie"
            @save="saveConfigPartie()"
            @cancel="modalConfiguePartie=false"
            :save="false"
            :cancel="true"
        >
            <div style="height: 300px">
             <s-info 
                :close="true"
                @close="modalJoueur=false"
                :open="modalJoueur && this.tournoi.addJoueurInProgress"
                id="inprogress_add_demo"
                    >Vous avez déjà ajouté un joueur. En mode démo, vous ne pouvez en ajouter qu'un lorsqu'un concours qui est en cours</s-info>
            <div class="menuButtons" v-if="partie!=null">
                <div>
                    <s-button 
                        :role="role" 
                        theme="is-danger" 
                        label="Reinitialiser" icon="sync-alt" 
                        @onclick="$emit('openModalReinit')"
                        mode="V"    
                        
                    />
                 </div>
                <div>
                    <s-button icon="file-excel" theme="is-info is-normal" label="Exporter en excel" @onclick="exportXLS()" mode="V"/>
               
                </div>
                 <div  >
                <s-button :disabled="partie.state!='WAITING' || club.id=='demo'" 
                                icon="user-plus" 
                                theme="is-primary is-normal" 
                                :label="club.id=='demo' ? 'Ajouter un joueur (non accessible en test)' : 'Ajouter un joueur'"
                                @onclick="$emit('modalJoueur')"
                                :role="role" 
                                mode="V"
                                
                    />&nbsp;
                 </div>
                 <div>
                <s-button :disabled="partie.state!='WAITING'" 
                            icon="user-friends" 
                            theme="is-primary is-normal" 
                            label="Ajouter un jeu vierge"
                            @onclick="addVierge"
                            :role="role" 
                            mode="V"
                />&nbsp;
                 </div>
                 <div>
                <s-button 
                    icon="trash"
                    label="Supprimer la partie"
                    theme="is-danger"
                    mode="V"
                    @onclick="modalDeletePartie=true"
                    :disabled="this.nbParties != indexPartie+1"/>
                    
                 </div>
               
                 <div>
                  <s-button 
                    :role="role" 
                    theme="is-dark" 
                    label="Joueurs en attente" icon="user-clock" 
                    @onclick="$emit('openPlayerClock')"
                    mode="V"    
                />   
                 </div>
               
                <div>
                  <s-button 
                    :role="role" 
                    theme="is-primary" 
                    label="Affecter des terrains" 
                    icon="th" 
                    @onclick="openTerrain()"
                    mode="V"    
                />   
                 </div>
                  <div>
                  <s-button 
                    :role="role" 
                    theme="is-primary" 
                    label="Affecter des timers" 
                    icon="clock" 
                    @onclick="openModalTimers=true"
                    mode="V"   
                    :disabled="partie.state=='INPROGRESS'" 
                />   
                 </div>
            </div>
             <s-confirm   
                :open="confirmReinit"
                :close="true"
                @close="confirmReinit=false"
                @yes="saveTerrains(true)"
                @no="saveTerrains(false)"
            >
                Souhaitez vous réinitialiser toutes les équipes ou seulement les équipes où il n'y pas encore de terrains ?
           </s-confirm>
            <s-modal    
                :open="modalTerrain"
                :close="true"
                @close="modalTerrain=false"
                :save="true"
                @save="confirmReinit=true;modalTerrain=false"
            >
                <div v-if="zonesClub.length==0">
                    <s-l id="notterraininclub">Ce club ne possède pas de terrains, veuillez retourner dans votre club pour les configurer</s-l>
                </div>
                <div v-if="zonesClub.length>0">
                    Veuillez sélectionner la zone que vous souhaitez affecter à votre concours :
                    <div v-for="zone in zonesClub" style="margin: 5px;display:inline-block">
                    <s-button 
                        @onclick="setTerrains(zone)" 
                        :label="zone.name + ' (' + (zone.nb - zone.nbNotDispo) + ' terrains)'"
                        :theme="zone.check ? 'is-success' : 'is-primary'"/>&nbsp;
                    </div>
                    <div v-show="hasTournoiZones">
                        Il n'y pas (ou plus) de terrains qui seront affectés à ce tournoi
                    </div>
                </div>
            </s-modal>
            <s-confirm 
                        :open="modalDeletePartie && this.nbParties>1"
                        @no="modalDeletePartie = false"
                        @yes="deletePartie()"
                    >
                        Confirmez vous la suppression de cette partie ?
                    </s-confirm>
                    <s-modal 
                        :open="modalDeletePartie && this.nbParties==1"
                        :close="true"
                        @close="modalDeletePartie=false"
                        
                        title="Suppression impossible"
                    >
                    Vous ne pouvez pas supprimer toutes les parties.<br/>
                    </s-modal>
           <div style="margin-top: 20px;text-align:center">
           Nombre de points maximum : 
           <input type="text" class="input is-primary is-rounded is-small" v-model="pointMaxCalc" style="width:50px"/>
           &nbsp;<s-button @onclick="saveConfigPartie" label="" icon="save" theme="is-success is-small"/>
           </div>
           </div>
           <modal-timers   
            :open="openModalTimers"
            @close="openModalTimers=false"
            :tournoi="tournoi"
            :club="club"
            :firestore="firestore"
            :equipes="equipes"
            :partie="partie"
            />
        </s-modal>
</template>
<style scoped>
    .menuButtons {
        text-align: center;
        width: 100%;
       
    }
    .menuButtons div {
        display: inline-block;
        vertical-align: top;
        margin-right: 5px;
    }
</style>
<script>
import firebase_api from '@/firebase/firebase_api'
import Equipe_object from '@/firebase/tirage2/Equipe'
import Terrain from "@/firebase/tirage2/Terrain"
import modalTimers from "@/views/tournoi/inProgress/modals/modalTimers.vue"
import XLSX from 'xlsx'
export default ({
   props: ["indexPartie","open", "parties","partie", "tournoi","pointMax", "club","role", "playersClock", "equipes", "firestore","modalJoueur"], 
   components: {
       modalTimers
   },
   data() {
       return {
           modalDeletePartie: false,      
           modalTerrain: false,
           zonesClub: [],
           confirmReinit: false,  
           openModalTimers: false   
       }
   },
   computed: {
       hasTournoiZones: {
           get() {
                return this.zonesClub.findIndex(zone=>zone.check === true) == -1;
            }
       },
       nbParties: {
           get() {
                if (typeof(this.parties)=="undefined")
                    return 0;
                else
                    return this.parties.length;
           }
       },
       pointMaxCalc: {
           get() {
               return this.pointMax;
           },
           set(val) {
               this.$emit("setPointMax", val);
           }
       }
   },
   methods: {
       setEquipes(options, partiesJSON) {
            var tournoiDoc = firebase_api.api.getDb().collection("club").doc(this.club.id)
            .collection("tournois").doc(this.tournoi.id);
            partiesJSON.forEach(partie=>{
                partie.equipes.forEach((equipe, indiceEquipe)=>{
                    tournoiDoc.collection("parties").doc(partie.id).collection("equipes").doc(equipe.id).update({
                        terrain: equipe.terrain
                    }).then(doc=>{
                        if (indiceEquipe == partie.equipes.length-1) {
                            this.$emit("reinitStateTerrainsTournois");
                            this.confirmReinit=false;
                            this.$emit("close");
                        }
                    })
                })
            })
            tournoiDoc.update({
                "options.zones": options.zones
            });
            
       },
       setTerrains(zone) {
            zone.check=!zone.check;
       },
       saveTerrains(reinitEquipe) {
           var partiesJSON = [];
           var tournoiDoc = firebase_api.api.getDb().collection("club").doc(this.club.id)
            .collection("tournois").doc(this.tournoi.id);
           var options = JSON.parse(JSON.stringify(this.tournoi.options));
           options.zones={};
           for (var indiceZoneClub in this.zonesClub) {
               var zoneClub = this.zonesClub[indiceZoneClub]
               if (zoneClub.check) {
                   var zoneClubJSON = JSON.parse(JSON.stringify(zoneClub));
                   delete zoneClubJSON["check"];
                   options.zones[zoneClub.name] = zoneClubJSON;
               }
           }
           this.parties.forEach((partie, indicePartie)=>{
               console.log(indicePartie);
               var partieJSON = JSON.parse(JSON.stringify(partie));
               partieJSON.id = partie.id;
               tournoiDoc.collection("parties").doc(partie.id).collection("equipes").get().then(equipes=>{
                   partieJSON.equipes=[];
                   for (var indiceEquipe in equipes.docs) {
                       var equipeData = equipes.docs[indiceEquipe].data();
                       delete equipeData[".key"];
                       equipeData.id = equipes.docs[indiceEquipe].id;
                       if (reinitEquipe) {
                           equipeData.terrain=null;
                       }
                       partieJSON.equipes.push(equipeData);
                       if (indiceEquipe == equipes.docs.length-1) {
                            partiesJSON.push(partieJSON);
                            if (indicePartie == this.parties.length-1) {
                                var terrain = new Terrain ()
                                terrain.init(options, partiesJSON);
                                this.setEquipes(options, partiesJSON);
                            }
                       }
                   }
               })
           })
       },
       openTerrain() {
           this.zonesClub=[];
            firebase_api.api.getDb().collection("club").doc(this.club.id).collection("terrains")
                .get().then(zones=>{
                    for (var zone in zones.docs) {
                        var zoneData = zones.docs[zone].data();
                        zoneData.check = false;
                        var zonesTournoi = this.tournoi.options.zones;
                        if (typeof(zonesTournoi)!="undefined") {
                           var bool = false;
                           for (var zoneTournoi in zonesTournoi) {
                               console.log(zoneTournoi);
                               console.log(zone);
                               if (!bool)
                                bool = zoneTournoi == zones.docs[zone].id;
                           }
                           zoneData.check = bool;
                        }
                        this.zonesClub.push(zoneData);
                    }
                })
           this.modalTerrain = true;
       },
        deletePartie() {
              
              this.firestore.partie.delete().then(()=>{
                    this.modalDeletePartie=false;
                    this.modalConfiguePartie=false;
                    if (this.indexPartie>0) {
                        this.$emit("changeIndexPartie",this.indexPartie-1);
                        this.$emit("close")
                    }
              })
          },
          saveConfigPartie() {
              this.firestore.partie.update({
                  maxPoint: this.pointMaxCalc
              })
              this.modalConfiguePartie=false;
          },
          
          // ****************************
            // Export XLS (peut à sortir)
            // ******************************
            addVierge() {
              var equipe = new Equipe_object();
              var idEquipe = "E" + this.equipes.length;
              this.firestore.equipes.doc(idEquipe).set(
                equipe.json
               );
              this.$emit("close");
            },
            
            
          async exportXLS() {
               var prepareXLS = [];
               var tournoiRef = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id);
               var partiesRef = await tournoiRef.collection("parties").get();
               var joueurs = [];
               var nbParties = 0;
               nbParties =  partiesRef.docs.length;
               for (var indexPartie in partiesRef.docs) {
                       var partieRef = partiesRef.docs[indexPartie];
                       
                       prepareXLS[indexPartie] = [];
                       var equipesRef = await partieRef.ref.collection("equipes").get();
                       var equipeJoueurs = [];
                       joueurs[indexPartie] = [];
                        equipesRef.docs.forEach((equipeRef, indiceEquipe)=>{
                                joueurs[indexPartie][indiceEquipe] = {};
                                var equipeData = equipeRef.data();
                                var amis=[];
                                var contre=[];
                                var ligneEquipe = {
                                    "Joueurs J1":null,
                                    "Joueurs J2":null,
                                    "Joueurs J3":null,
                                    "Joueurs Score": null,
                                    "Contre J1":null,
                                    "Contre J2":null,
                                    "Contre J3":null,
                                    "Contre Score": null
                                };
                                for (var key in equipeData.joueurs)
                                    if (equipeData.joueurs[key]!=null) {
                                        ligneEquipe["Joueurs "+key] = equipeData.joueurs[key].numero+1;
                                        amis.push(equipeData.joueurs[key].numero);
                                    }
                                for (var key in equipeData.contre)
                                    if (equipeData.contre[key]!=null) {
                                        ligneEquipe["Contre "+key] = equipeData.contre[key].numero+1;
                                        contre.push(equipeData.contre[key].numero);
                                    }
                                joueurs[indexPartie][indiceEquipe].amis = amis;
                                joueurs[indexPartie][indiceEquipe].contre = contre;
                                ligneEquipe["Joueurs Score"] = equipeData.score.joueurs;
                                ligneEquipe["Contre Score"] = equipeData.score.contre;
                                equipeJoueurs.push(ligneEquipe);
                        })
                        prepareXLS[indexPartie] = equipeJoueurs;
               }
             
                var wb = XLSX.utils.book_new() // make Workbook of Excel
               prepareXLS.forEach((prepareItem, indexPartie)=>{
                   var prepareToSheet = XLSX.utils.json_to_sheet(prepareItem);
                   XLSX.utils.book_append_sheet(wb, prepareToSheet, 'Partie '+(indexPartie+1)) // sheetAName is name of Worksheet
               })
               var consoJoueurs = [];
               joueurs.forEach((joueurPartie, indexPartie)=>{
                   joueurPartie.forEach(equipe=>{
                       equipe.amis.forEach(ami=>{
                           if (typeof(consoJoueurs[ami])=="undefined") {
                               consoJoueurs[ami] = {
                                   joueur : ami+1
                               }
                               for (var i=1;i<=nbParties;i++) {
                                    consoJoueurs[ami][i + " amis J1"] = null; 
                                    consoJoueurs[ami][i + " amis J2"] = null;
                                    consoJoueurs[ami][i + " amis J3"] = null;
                                    consoJoueurs[ami][i + " contre J1"] = null; 
                                    consoJoueurs[ami][i + " contre J2"] = null;
                                    consoJoueurs[ami][i + " contre J3"] = null;
                               }
                           }
                           equipe.amis.forEach((ami2, indiceAmi2)=>{
                               if (ami!=ami2) {
                                   consoJoueurs[ami][(indexPartie+1) + " amis J"+(indiceAmi2+1)] = ami2+1;
                               }
                           })
                           equipe.contre.forEach((contre2,indiceContre2)=>{
                                consoJoueurs[ami][(indexPartie+1) + " contre J"+ (indiceContre2+1)] = contre2+1;                              
                           })
                       })
                       equipe.contre.forEach(contre=>{
                           if (typeof(consoJoueurs[contre])=="undefined") {
                               consoJoueurs[contre] = {
                                   joueur: contre+1
                               }
                               for (var i=1;i<=nbParties;i++) {
                                    consoJoueurs[contre][i + " amis J1"] = null; 
                                    consoJoueurs[contre][i + " amis J2"] = null;
                                    consoJoueurs[contre][i + " amis J3"] = null;
                                    consoJoueurs[contre][i + " contre J1"] = null; 
                                    consoJoueurs[contre][i + " contre J2"] = null;
                                    consoJoueurs[contre][i + " contre J3"] = null;
                               }
                           }
                           equipe.contre.forEach((contre2,indiceContre2)=>{
                               if (contre!=contre2) {
                                   consoJoueurs[contre][(indexPartie+1) + " amis J"+ (indiceContre2+1)] = contre2+1;
                               }
                           })
                           equipe.amis.forEach((ami2, indiceAmi2)=>{
                                   consoJoueurs[contre][(indexPartie+1) + " contre J"+(indiceAmi2+1)] = ami2+1;
                           })
                       })
                   })
               })
               
                var consoJoueursToSheet = XLSX.utils.json_to_sheet(consoJoueurs);
                   XLSX.utils.book_append_sheet(wb, consoJoueursToSheet, 'joueurs') 
                
                var today = new Date(this.tournoi.date);
                var dd = (today.getDate() < 10 ? '0' : '') + today.getDate();
                // 01, 02, 03, ... 10, 11, 12
                var MM = ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1);

                var nameFile = this.club.id + " CONCOURS " + today.getFullYear() + ''+ MM + '' + dd + ".xlsx";
                // export Excel file
                XLSX.writeFile(wb, nameFile) // name of the file is 'book.xlsx'
          },
   }
})
</script>
